var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.942 6.36c-3.578 3.577-1.376 5.228 0 5.779 1.926-.002 3.302-2.203 4.127-4.13.825-1.925 2.476-3.026 7.98-3.026 5.503 0 5.778 4.403 5.228 6.604-.55 2.201-6.054 5.504-7.43 4.953-1.376-.55.826-3.851 1.376-5.227.55-1.376.275-1.926-1.376-1.926S5.492 23.696 4.667 25.622c-.826 1.926-.826 3.577.275 4.128 1.1.55 1.926.275 3.302-1.651 1.1-1.542 2.66-5.78 3.302-7.706.917 1.834 3.082 5.888 4.403 7.43 1.65 1.926 2.75 1.926 6.328 1.375 3.577-.551 6.053-3.853 6.053-5.504.001-1.651-1.374-.826-1.925 0-.55.825-3.027 3.577-6.604 2.752-2.86-.66-3.943-4.678-4.126-6.605.55-.183 1.926-.66 3.026-1.1 1.376-.55 4.678-1.927 6.605-4.678 1.926-2.752 2.2-11.007-4.678-11.833-6.88-.825-12.108.55-15.685 4.128z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReef);
export default __webpack_public_path__ + "static/media/REEF.4f51e5475dc82389736bc26102d7317c.svg";
export { ForwardRef as ReactComponent };